export default __webpack_public_path__ + "static/media/brands-istse.e20f49ac.png";